export enum ChecklistStep {
  NO_STEPS,
  EVENT_CREATED,
  PRODUCT_CREATED,
  CUSTOMER_CREATED,
  BOOKING_TOOL_SHARED,
  STUDIO_DATA_CHECKED,
  DONE,
}

export enum PartnerPortalChecklistStep {
  NO_STEPS,
  PROFILE_UPDATED,
  EVENT_EDITED,
  STUDIO_DATA_EDITED,
  STAFF_EDITED,
  DONE,
}

export enum CreatedPartnerPortalChecklistStep {
  NO_STEPS,
  STUDIO_UPDATED,
  EVENT_CREATED,
  REQUEST_APPROVAL,
  DONE,
}
